import ChartTestClientPsychDepressiviteit from "../../../../src/client/testclient-psych/json/depressiviteit.json";
import ChartTestclientPsych from "../../../../src/client/testclient-psych/chart/Chart.js";
import * as React from 'react';
export default {
  ChartTestClientPsychDepressiviteit,
  ChartTestclientPsych,
  React
};